module.exports = __webpack_public_path__ + "img/ml.c29c86be.svg";